 
const apMenu = [
  {
    System: 'MRP',
    isActive: false,
    menu: [
      // { is_header: true, title: 'إدارة المدفوعات', isActive: true },
      { is_header: true, title: 'إدارة الإنتاج والتصنيـع', isActive: true },

    
    
         {
        path: '/MRP/HomePage',
        icon: 'fas fa-home',
        title: 'HomePage',
        isActive: true
      },


      { is_header: true, title: 'Settings', isActive: true },

      {
        path: 'MRP/Settings/Processes',
        icon: 'fas fa-handshake',
        title: 'العمليــات',
        isActive: true,
      },
      {
        path: 'MRP/Settings/Products',
        icon: 'fas fa-handshake',
        title: 'Products',
        isActive: true,
      },

      // { is_header: true, title: 'Operations', isActive: true },

      { is_header: true, title: 'Reports', isActive: true },
      {
        path: 'Finance/Ap/ApReports',
        icon: 'fas fa-chart-line',
        title: 'Reports',
        isActive: true,
      },
      {
        path: 'Finance/Ap/ApDashboards',
        icon: 'fas fa-th-large',
        title: 'Dashboard',
        isActive: true,
      },
    ],
  },
];

export default apMenu;
